import CoreCallToAction from './CoreCallToAction';

export { type CoreCallToActionProps } from './CoreCallToAction';
export default CoreCallToAction;
